import { cloneElement, Component } from 'react';
import PropTypes from 'proptypes';
import RouterData from './stores/RouterStore';

class RouterWrapperComponent extends Component {

  componentWillMount() {
    RouterData.activeRoute = window.location.pathname;
  }

  render() {
    return <div>{cloneElement(this.props.children, { ...this.props })}</div>;
  }
}

RouterWrapperComponent.propTypes = {
  children: PropTypes.node,
};

RouterWrapperComponent.defaultProps = {
  children: PropTypes.node,
};

export default RouterWrapperComponent;
